export default "__VITE_ASSET__a206e844__"